export const margin = {
    xl: 64 as const,
    l: 32 as const,
    ml: 24 as const,
    m: 16 as const,
    s: 8 as const,
    xs: 4 as const,
};
